import { commentItems } from '@/mocks/homeData';

export default function SectionComments() {
  return (
    <section id="comments" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            剧迷热评
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            听听追剧同好们怎么说，好口碑才是最好的推荐
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6 max-w-5xl mx-auto">
          {commentItems.map((item) => (
            <div
              key={item.id}
              className="bg-background-50 border border-background-200/70 rounded-xl p-5 md:p-6 flex flex-col"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
                  <img
                    src={item.avatar}
                    alt={item.name}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div className="min-w-0">
                  <div className="text-sm font-semibold text-foreground-950 truncate">
                    {item.name}
                  </div>
                  <div className="text-xs text-foreground-500 flex items-center gap-1.5 whitespace-nowrap">
                    在看《{item.show}》
                  </div>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed flex-1 mb-3">
                {item.content}
              </p>
              <div className="flex items-center gap-2 text-xs text-foreground-400">
                <i className="ri-time-line"></i>
                {item.date}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}